import React from "react";
import * as UserContext from "./UserContext";

export default function ClientRender(props) {
  const { hasLoaded } = React.useContext(UserContext.Context);

  return hasLoaded && props.children;
}
